module.exports = __webpack_public_path__ + "img/streak.9af3acd0.svg";